import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
  ScrollingModule,
} from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared';
import { DndModule } from '@app/shared/modules/dnd/dnd.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { CanDeactivatePanelGuard } from '@radioking/shared/pannel-manager';
import { UiBoxFilterModule } from '@radioking/ui/box-filter';
import { UiButtonModule } from '@radioking/ui/button';
import { UiInputModule } from '@radioking/ui/input';
import { UiInputColorPickerModule } from '@radioking/ui/input-color-picker';
import { UiMobileFabButtonModule } from '@radioking/ui/mobile-fab-button';
import { UiPageTitleModule } from '@radioking/ui/page-title';
import { UiPerfectScrollBarModule } from '@radioking/ui/perfect-scroll-bar';
import { UiPlaylistIconModule } from '@radioking/ui/playlist-icon';
import { UiTrackInputWithSuggestionsModule } from '@radioking/ui/track-input-with-suggestions';
import { KeyFilterModule } from 'primeng/keyfilter';

import { DirectivesModule } from '../../../directives/directives.module';
import { PipesModule } from '../../../shared/pipes/pipes.module';

import { UiTooltipModule } from '@radioking/ui/tooltip';
import { DeleteProgramModalComponent } from './components/modals/delete-program-modal/delete-program-modal.component';
import { DuplicateProgramModalComponent } from './components/modals/duplicate-program-modal/duplicate-program-modal.component';
import { PreviewProgramModalComponent } from './components/modals/preview-program-modal/preview-program-modal.component';
import { ProgramAddPlaylistModalComponent } from './components/modals/program-add-playlist-modal/program-add-playlist-modal.component';
import { ProgramDeletePlaylistModalComponent } from './components/modals/program-delete-playlist-modal/program-delete-playlist-modal.component';
import { ProgramEditPlaylistModalComponent } from './components/modals/program-edit-playlist-modal/program-edit-playlist-modal.component';
import { ProgramDetailsHeaderComponent } from './components/program-details-header/program-details-header.component';
import { ProgramDetailsListLineComponent } from './components/program-details-list-line/program-details-list-line.component';
import { ProgramDetailsListComponent } from './components/program-details-list/program-details-list.component';
import { ProgramDetailsComponent } from './components/program-details/program-details.component';
import { ProgramLineComponent } from './components/program-line/program-line.component';
import { ProgramsHeaderComponent } from './components/programs-header/programs-header.component';
import { ProgramsListComponent } from './components/programs-list/programs-list.component';
import { ProgramsShellComponent } from './components/programs-shell/programs-shell.component';
import { CreateProgramComponent } from './components/sides/create-program/create-program.component';
import { EditProgramComponent } from './components/sides/edit-program/edit-program.component';
import { IntroExtroComponent } from './components/sides/intro-extro/intro-extro.component';
import { MobDeleteProgramComponent } from './components/sides/mob-delete-program/mob-delete-program.component';
import { MobProgramAddPlaylistComponent } from './components/sides/mob-program-add-playlist/mob-program-add-playlist.component';
import { MobProgramChangePlaylistComponent } from './components/sides/mob-program-change-playlist/mob-program-change-playlist.component';
import { MobProgramDeletePlaylistComponent } from './components/sides/mob-program-delete-playlist/mob-program-delete-playlist.component';
import { MobProgramDetailsComponent } from './components/sides/mob-program-details/mob-program-details.component';
import { MobProgramEditPlaylistComponent } from './components/sides/mob-program-edit-playlist/mob-program-edit-playlist.component';
import { ProgramFindResolver } from './resolvers/program-find.resolver';
import { ProgramsState } from './states/programs.state';

const routes: Route[] = [
  {
    path: '',
    component: ProgramsShellComponent,
    canDeactivate: [CanDeactivatePanelGuard],
    children: [
      {
        path: '',
        component: ProgramsListComponent,
      },
      {
        path: 'program/:programId',
        component: ProgramDetailsComponent,
        resolve: { program: ProgramFindResolver },
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    UiButtonModule,
    UiInputModule,
    UiInputColorPickerModule,
    UiTrackInputWithSuggestionsModule,
    NgxsModule.forFeature([ProgramsState]),
    PipesModule,
    MatIconModule,
    ContextMenuModule,
    UiPerfectScrollBarModule,
    SharedModule,
    ReactiveFormsModule,
    ScrollingModule,
    MatMenuModule,
    DndModule,
    MatRadioModule,
    KeyFilterModule,
    DirectivesModule,
    UiPlaylistIconModule,
    UiPageTitleModule,
    UiMobileFabButtonModule,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    UiBoxFilterModule,
    MatStepperModule,
    MatButtonToggleModule,
    UiTooltipModule,
  ],
  declarations: [
    ProgramsShellComponent,
    ProgramsHeaderComponent,
    ProgramsListComponent,
    ProgramDetailsComponent,
    ProgramLineComponent,
    CreateProgramComponent,
    EditProgramComponent,
    ProgramDetailsHeaderComponent,
    ProgramDetailsListComponent,
    ProgramDetailsListLineComponent,
    PreviewProgramModalComponent,
    ProgramAddPlaylistModalComponent,
    DeleteProgramModalComponent,
    ProgramEditPlaylistModalComponent,
    DuplicateProgramModalComponent,
    ProgramDeletePlaylistModalComponent,
    MobProgramDetailsComponent,
    IntroExtroComponent,
    MobProgramAddPlaylistComponent,
    MobProgramEditPlaylistComponent,
    MobProgramDeletePlaylistComponent,
    MobProgramChangePlaylistComponent,
    MobDeleteProgramComponent,
  ],
})
export class ProgramsModule {}
